import * as api from "./index";
const t = "/invitations";

export default {
  get: api.get(t),
  create: api.post(t),
  getItem: api.get(`${t}/item/:id`),
  remove: api.del(`${t}/item/:id`),
};
